export default __webpack_public_path__ + "static/media/viking2.979b177e.jpeg";